"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NearMobileSignerProxy = void 0;
const config_1 = __importDefault(require("../../common/config/config"));
const SignerRequestStatus_1 = require("../../data-access/api/models/models/SignerRequestStatus");
const service_1 = require("../../data-access/api/service");
const visibilityAwareTimeoutPolling_1 = require("./utils/visibilityAwareTimeoutPolling");
class NearMobileSignerProxy {
    createRequest(network, request, metadata) {
        return __awaiter(this, void 0, void 0, function* () {
            const signerRequest = yield service_1.SignerRequestApi.createSignerRequest({ network, transactions: request, dAppMetadata: metadata });
            return signerRequest;
        });
    }
    getPollingConfig() {
        return {
            maxIterations: config_1.default.polling.maxIterations,
            visibilityCheckTimeout: config_1.default.polling.backgroundVisibilityCheckTimeout,
            visibilityCheckInterval: config_1.default.polling.backgroundVisibilityCheckInterval,
            timeout: config_1.default.polling.requestTimeout,
        };
    }
    awaitActionSignatureResolution(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, visibilityAwareTimeoutPolling_1.visibilityAwareTimeoutPolling)(() => service_1.SignerRequestApi.getSignerRequestStatus(id), ({ status }) => status === SignerRequestStatus_1.SignerRequestStatus.PENDING, this.getPollingConfig());
        });
    }
    getRequest(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield service_1.SignerRequestApi.getSignerRequest(id);
        });
    }
    createSignMessage(network, message, receiver, nonce, callbackUrl, metadata) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield service_1.SignerRequestApi.createSignMessageRequest({
                network,
                message,
                receiver,
                nonce,
                callbackUrl,
                receiverMetadata: metadata,
            });
        });
    }
    awaitMessageSignatureResolution(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, visibilityAwareTimeoutPolling_1.visibilityAwareTimeoutPolling)(() => service_1.SignerRequestApi.getSignMessageRequest(id), ({ response, status }) => !response && status === SignerRequestStatus_1.SignerRequestStatus.PENDING, this.getPollingConfig());
        });
    }
    rejectSignerRequest(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield service_1.SignerRequestApi.rejectSignerRequest(id);
        });
    }
    rejectMessageRequest(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield service_1.SignerRequestApi.rejectMessageRequest(id);
        });
    }
}
exports.NearMobileSignerProxy = NearMobileSignerProxy;
